import { Button, Tooltip, Typography } from "@mui/material";
import { FC, MouseEventHandler, useRef } from "react";

import { useTooltipText } from "../../../../../Hooks/useTooltipText";

interface StaticViewItemProps {
    selectElement: MouseEventHandler<HTMLButtonElement>;
    elementName: string;
}

const StaticViewItem: FC<StaticViewItemProps> = ({ selectElement, elementName }) => {
    const ref = useRef<HTMLHeadingElement>(null);
    const tooltipText = useTooltipText(ref, elementName);

    return (
        <Button
            onClick={selectElement}
            sx={{
                lineHeight: 0,
                width: "100%",
                alignItems: "center",
                flexDirection: "row",
                justifyContent: "space-between",
                minHeight: "46px",
                "& .MuiSvgIcon-root": { cursor: "pointer", opacity: 0, transition: "all 250ms" },
                "& .MuiTypography-root": { color: (theme) => theme.palette.cobaltBlue?.main },
                backgroundColor: (theme) => theme.palette.cobaltBlue?.light,
                ":hover": {
                    backgroundColor: (theme) => theme.palette.cobaltBlue?.hover,
                    "& .MuiSvgIcon-root": { opacity: 0.5, ":hover": { opacity: 1 } },
                    "& .MuiTypography-root": { color: (theme) => theme.palette.primary.contrastText },
                },
                "&.MuiButton-root": {
                    color: (theme) => theme.palette.teal?.main,
                },
            }}
        >
            <Tooltip title={tooltipText} placement="top" arrow>
                <Typography
                    ref={ref}
                    component="h6"
                    variant="body1"
                    sx={{
                        textAlign: "center",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                    }}
                >
                    {elementName}
                </Typography>
            </Tooltip>
        </Button>
    );
};

export default StaticViewItem;
